import Loader from './Loader';
export default function FullScreenLoading() {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center">
      <Loader loading />
    </div>
  );
}
